import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

export const VisionSection = () => {
  return (
    <section className="py-20 bg-black text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23fbbf24' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="mb-8">
            <Sparkles className="h-16 w-16 text-yellow-400 mx-auto mb-6" />
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">
              Visión Futura
            </h2>
            <p className="text-xl text-slate-300 max-w-4xl mx-auto leading-relaxed mb-8">
              Nuestro compromiso es evolucionar junto a ti. NOVOPAY seguirá creciendo para ofrecer nuevas 
              herramientas que simplifiquen la gestión financiera, potencien la productividad y promuevan 
              un ecosistema digital más humano.
            </p>
          </div>
          
          <div className="bg-yellow-500/20 backdrop-blur-sm border border-yellow-500/30 rounded-2xl p-8 md:p-12 mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold text-yellow-400 mb-4">
              NOVOPAY — Tecnología que impulsa la libertad financiera.
            </h3>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto">
              Únete a la revolución de soluciones financieras que está transformando la manera de entender y gestionar el dinero.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              asChild
              size="lg" 
              className="bg-yellow-500 hover:bg-yellow-600 text-black px-8 py-4 text-lg font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <a href="https://wa.me/525538164204?text=Hola%2C%20quiero%20abrir%20mi%20cuenta%20en%20NOVOPAY" target="_blank" rel="noopener noreferrer" data-testid="vision-signup-link">
                Comienza Ahora
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
